import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

// Check that service workers are registered
if ('serviceWorker' in navigator) {
  // Use the window load event to keep the page load performant
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
  })
}

new Vue({
  render: h => h(App)
}).$mount('#app')
